import React, {useEffect, useState} from "react";
import {API_ROOT} from "../../../baseUrls";
import {connect} from "react-redux";
import {Box, Container, Typography} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import AvatarWaitTimer from "../../organisms/loader/AvatarWaitTimer";

function Interview({ bot_unique, bot_security, avatarReady }) {
  const [interviewUrl, setInterviewUrl] = useState(false);

  useEffect(() => {
    if (bot_unique && bot_security && avatarReady) {
      fetch(
        `${API_ROOT}/ai/lifenaut?unique=${bot_unique}&security=${bot_security}`,
        {
          method: "GET",
          credentials: "include",
        }
      )
        .then(resp => resp.text())
        .then(text => {
          var match = text.match(/fLoc\('(.*)?'\)[^>]*>Guided Conversations/);
          if (match) {
            setInterviewUrl(match[1]);
          } else {
            setInterviewUrl(false);
          }
        });
    }
  }, [bot_unique, bot_security, avatarReady]);

  if (!avatarReady) {
    return <AvatarWaitTimer />;
  }

  return (
    <Container>
      <Box mt={5}>
        <Typography variant="h4">
          Interview
          <Button
              variant="contained"
              color="primary"
              style={{marginLeft: '2em'}}
              onClick={() => document.getElementById('interviewFrame').src=`${API_ROOT}/ai/${interviewUrl}`}>
            Test Home
          </Button>
        </Typography>
        <Box mt={3}>
          {interviewUrl ? (
            <iframe
            id='interviewFrame'
              src={`${API_ROOT}/ai/${interviewUrl}`}
              title="Interview"
              style={{ width: "100%", height: 500 }}
            />
          ) : null}
        </Box>
      </Box>
    </Container>
  );
}

const mapStateToProps = state => ({
  bot_unique: state.mindfile.bot_unique,
  bot_security: state.mindfile.bot_security,
  avatarReady: !state.avatarReadyAt,
});

export default connect(mapStateToProps)(Interview);
